import TypeProfile from './type-profile';

export default TypeProfile;